import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';

const Paragraph = ({ children, className }) => (
  <StyledParagraph className={className}>
    {children}
  </StyledParagraph>
);

const StyledParagraph = styled.p`
  color: ${theme.colors.text.primary};
  font-size: 18px;
  line-height: 1.5;
   
  a {
    color: ${theme.colors.primary}
  }
`;

export default Paragraph;